import { PAY_METHODS, PAY_METHOD_BY_KEY, defaultMethod, methodLabel } from "@rental/shared";
import { C, inputStyle } from "./theme.js";

/* ============================================================================
   בחירת אמצעי תשלום.

   הסימון עצמו נשאר לחיצה אחת — הבורר יושב לצידו ומראה מה נרשם, ומשנה
   רק כשצריך. הערך תמיד מוצג: "התקבל" בלי לדעת איך זה מה שהופך את
   ההצלבה מול דף הבנק לניחוש, ומזומן נעלם בלי זכר.
   ============================================================================ */

export default function MethodPick({ value, onChange, compact = false, disabled = false }) {
  // ערך ריק על תשלום קיים = נתון ישן, מלפני שהשדה הזה היה קיים.
  const current = PAY_METHOD_BY_KEY[value] ? value : "";

  return (
    <select
      value={current}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value || null)}
      aria-label="אמצעי תשלום"
      title={current ? `שולם ב${methodLabel(current)}` : "לא נרשם אמצעי תשלום"}
      style={{
        ...inputStyle,
        width: "auto",
        padding: compact ? "3px 6px" : "5px 8px",
        fontSize: compact ? 11 : 12,
        color: current ? C.ink : C.muted,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {!current && <option value="">איך שולם?</option>}
      {PAY_METHODS.map((m) => (
        <option key={m.k} value={m.k}>{compact ? m.short : m.label}</option>
      ))}
    </select>
  );
}

/** תווית קצרה לתצוגה בלבד, לשורות שאין בהן עריכה. */
export function MethodTag({ value, muted = false }) {
  const m = PAY_METHOD_BY_KEY[value];
  if (!m) return null;
  return (
    <span className="text-[10px] rounded px-1.5 py-0.5 whitespace-nowrap"
      style={{ background: muted ? "transparent" : "#F1F4F1", color: C.muted }}>
      {m.short}
    </span>
  );
}

/** שלוש ברירות המחדל, למסך ההגדרות. */
export function MethodDefaults({ settings, onChange }) {
  const rows = [
    { k: "payMethodRent", label: "שכר דירה", kind: "rent" },
    { k: "payMethodBills", label: "חשבונות צריכה", kind: "elec" },
    { k: "payMethodVaad", label: "ועד בית", kind: "vaad" },
  ];

  return (
    <div className="grid sm:grid-cols-3 gap-3">
      {rows.map(({ k, label, kind }) => (
        <div key={k} className="rounded-lg border p-3" style={{ borderColor: C.line }}>
          <div className="text-sm mb-2">{label}</div>
          <MethodPick
            value={settings[k] || defaultMethod(settings, kind)}
            onChange={(v) => onChange(k, v || defaultMethod(settings, kind))}
          />
        </div>
      ))}
    </div>
  );
}
